import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Facebook, Instagram, Twitter, Youtube, Globe } from "react-feather"

const icons = {
    facebook: Facebook,
    instagram: Instagram,
    twitter: Twitter,
    youtube: Youtube,
}

const ListItem = ({ data }) => {
    const Icon = icons[String(data.name).toLowerCase()] || Globe

    return (
        <li className="inline-block mr-3">
            <a
                href={data.url}
                title={data.name}
                aria-label={data.name}
                target="_blank"
                rel="noopener noreferrer"
                className="social-btn text-color-1"
            >
                <Icon strokeWidth={1.4} />
            </a>
        </li>
    )
}

export default ({ className = "" }: { className?: string }) => {
    const data = useStaticQuery(graphql`
        query SocialQuery {
            site {
                siteMetadata {
                    social {
                        name
                        url
                        icon
                    }
                }
            }
        }
    `)

    const items = data.site.siteMetadata.social
    const list = items.map((e, i) => <ListItem key={e.url + "-" + i} data={e} />)

    return <ul className={`flex items-center ${className}`}>{list}</ul>
}
